import React from 'react';
import type { RecurrenceRule, RecurrenceWeekday } from '../types';

const WEEKDAYS: Array<{ key: RecurrenceWeekday; label: string }> = [
  { key: 'Mon', label: 'Mon' },
  { key: 'Tue', label: 'Tue' },
  { key: 'Wed', label: 'Wed' },
  { key: 'Thu', label: 'Thu' },
  { key: 'Fri', label: 'Fri' },
  { key: 'Sat', label: 'Sat' },
  { key: 'Sun', label: 'Sun' },
];

export function RecurrenceEditor(props: {
  value: RecurrenceRule;
  onChange: (next: RecurrenceRule) => void;
  disabled?: boolean;
}): React.ReactElement {
  const { value, onChange, disabled } = props;

  return (
    <div className="border rounded p-3 bg-light">
      <label className="form-label mb-1">Days of week</label>
      <div className="d-flex flex-wrap gap-2">
        {WEEKDAYS.map((d) => {
          const checked = (value.byWeekday ?? []).includes(d.key);
          return (
            <label key={d.key} className="form-check form-check-inline m-0">
              <input
                type="checkbox"
                className="form-check-input"
                checked={checked}
                disabled={disabled}
                onChange={(e) => {
                  const next = new Set(value.byWeekday ?? []);
                  if (e.target.checked) next.add(d.key);
                  else next.delete(d.key);
                  const list = Array.from(next);
                  onChange({
                    ...value,
                    frequency: 'Weekly',
                    interval: 1,
                    ends: { kind: 'never' },
                    byWeekday: (list.length ? list : ['Mon']) as RecurrenceWeekday[],
                  });
                }}
              />
              <span className="form-check-label">{d.label}</span>
            </label>
          );
        })}
      </div>
      <small className="text-muted d-block mt-2">
        Weekly schedule. End the recurrence from the event/class after it&apos;s created.
      </small>
    </div>
  );
}

